export const kecDescribeInstances = 'recycle/kecDescribeInstances';
export const kecGetProjList = 'recycle/kecGetProjList';
export const kecSearchInstances = 'recycle/kecSearchInstances';
export const RecoveryInstances = 'recycle/RecoveryInstances';
export const DeleteInstances = 'recycle/DeleteInstances';
